import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class clearanceCheckModel extends Model {

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'view',
			checkType: 'WorkingWithChildrenCheck',
			file_name: '',
			title: '',
			data: {
				validFrom: '',
				validTo: '',
				base64: '',
				type: '',
				ext: ''
			}
		}
	}

	options() {
		return {
			methods: {
				view: 'GET',
				save: 'POST'
			}
		}
	}

	routes() {
		return {
			view: 'interpreter/clearance_check/{checkType}/get_image?token=',
			save: 'interpreter/clearance_check/{checkType}/send'
		}
	}

	requestRoute() {
		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.methodTypes);
		let route = this.inBuiltApi + this.getRoute(this.methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);
		let data = this.data;

		// console.log(headers, method, url, data);

		return this.getRequest({headers, method, url, data}).send();
	}

	saveFile(checkType) {
		this.methodTypes = 'save';
		this.checkType = checkType;
		return this.requestRoute();
	}
}
